import React, { Component } from "react";
import {
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { SERVER_URL } from "../constants/variables";
import { getAuthHeaders, getEntityId, getUserRoleId } from "../utils/api";
import Sidebar from "./Sidebar";
import toast from "react-hot-toast";
import { IoCreateOutline, IoTrashOutline, IoPersonAddOutline, IoSearchOutline, IoChevronDownOutline, IoChevronForwardOutline } from "react-icons/io5";
import "./TabsComponent.css";
import "./RolesComponent.css";

class RolesComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {},
      roles: [],
      roleTabs: [],
      idRoleMap: {},
      addModalOpen: false,
      editModalOpen: false,
      editingRoleId: null,
      editingRoleName: "",
      roleName: "",
      deleteConfirmId: null,
      isLoading: false,
      addUserModalOpen: false,
      signupEmail: "",
      signupPassword: "",
      signupFirstName: "",
      signupLastName: "",
      signupRole: "",
      users: [],
      usersLoading: false,
      search: "",
      expandedRoleIds: [],
    };

    this.handleInputChange = this.handleInputChange.bind(this);
  }

  toggleAddModal = () => {
    this.setState({
      roleName: "",
      addModalOpen: !this.state.addModalOpen,
    });
  };

  toggleEditModal = (role = null) => {
    this.setState({
      editModalOpen: !this.state.editModalOpen,
      editingRoleId: role ? getEntityId(role) : null,
      editingRoleName: role ? role.name : "",
    });
  };

  toggleAddUserModal = () => {
    const { roles } = this.state;
    this.setState({
      addUserModalOpen: !this.state.addUserModalOpen,
      signupEmail: "",
      signupPassword: "",
      signupFirstName: "",
      signupLastName: "",
      signupRole: roles.length ? String(getEntityId(roles[0])) : "",
    });
  };

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    this.setState({ [name]: value });
  }

  onAddRoleSubmit = () => {
    const roleName = this.state.roleName?.trim();
    if (!roleName) {
      toast.error("Enter role name");
      return;
    }
    toast.loading("Adding role...", { duration: 2000 });
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    const authHeaders = getAuthHeaders();
    if (authHeaders.Authorization) myHeaders.append("Authorization", authHeaders.Authorization);

    fetch(SERVER_URL + "/roles/addRole", {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({ name: roleName }),
      redirect: "follow",
    })
      .then((res) => res.json())
      .then((result) => {
        toast.success("Role added successfully");
        this.getRoles();
        this.toggleAddModal();
      })
      .catch(() => {
        toast.error("Failed to add role");
      });
  };

  onUpdateRoleSubmit = () => {
    const { editingRoleId, editingRoleName } = this.state;
    const name = editingRoleName?.trim();
    if (!editingRoleId || !name) {
      toast.error("Enter role name");
      return;
    }
    toast.loading("Updating role...", { duration: 2000 });
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    const authHeaders = getAuthHeaders();
    if (authHeaders.Authorization) myHeaders.append("Authorization", authHeaders.Authorization);

    fetch(SERVER_URL + "/roles/updateRole", {
      method: "PUT",
      headers: myHeaders,
      body: JSON.stringify({ role: editingRoleId, name }),
      redirect: "follow",
    })
      .then((res) => res.json())
      .then((result) => {
        toast.success("Role updated successfully");
        this.getRoles();
        this.toggleEditModal();
      })
      .catch(() => {
        toast.error("Failed to update role");
      });
  };

  getRoles = () => {
    this.setState({ isLoading: true });
    fetch(SERVER_URL + "/roles/getRoles", {
      method: "GET",
      headers: getAuthHeaders(),
      redirect: "follow",
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.success && result.roles) {
          const map = {};
          result.roles.forEach((item) => {
            map[getEntityId(item)] = item.name;
          });
          this.setState({ roles: result.roles, idRoleMap: map, isLoading: false });
        } else {
          this.setState({ isLoading: false });
        }
      })
      .catch(() => {
        this.setState({ isLoading: false });
      });
  };

  getUsers = () => {
    this.setState({ usersLoading: true });
    fetch(SERVER_URL + "/users", {
      method: "GET",
      headers: getAuthHeaders(),
      redirect: "follow",
    })
      .then((res) => res.json())
      .then((data) => {
        const list = Array.isArray(data) ? data : (data && data.users) ? data.users : [];
        this.setState({ users: list, usersLoading: false });
      })
      .catch(() => {
        this.setState({ usersLoading: false });
      });
  };

  getTabsByRole = (roleId) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    const authHeaders = getAuthHeaders();
    if (authHeaders.Authorization) myHeaders.append("Authorization", authHeaders.Authorization);

    fetch(SERVER_URL + "/tabs/getTabsByRole", {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({ role: roleId }),
      redirect: "follow",
    })
      .then((res) => res.json())
      .then((result) => {
        this.setState({ roleTabs: result.tabs || [] });
      })
      .catch(() => {});
  };

  deleteRole = (id) => {
    this.setState({ deleteConfirmId: id });
  };

  confirmDeleteRole = () => {
    const id = this.state.deleteConfirmId;
    if (id == null) return;
    this.setState({ deleteConfirmId: null });
    toast.loading("Deleting...", { duration: 2000 });
    const myHeaders = new Headers();
    myHeaders.append("role", id);
    const authHeaders = getAuthHeaders();
    if (authHeaders.Authorization) myHeaders.append("Authorization", authHeaders.Authorization);

    fetch(SERVER_URL + "/roles/deleteRole", {
      method: "DELETE",
      headers: myHeaders,
      redirect: "follow",
    })
      .then((res) => res.json())
      .then((result) => {
        toast.success("Role deleted successfully");
        this.getRoles();
      })
      .catch(() => {
        toast.error("Failed to delete role");
      });
  };

  cancelDelete = () => {
    this.setState({ deleteConfirmId: null });
  };

  onAddUserSubmit = () => {
    const { signupEmail, signupPassword, signupFirstName, signupLastName, signupRole } = this.state;
    const email = signupEmail?.trim();
    const password = signupPassword?.trim();
    const first_name = signupFirstName?.trim();
    const last_name = signupLastName?.trim();
    const roleId = signupRole ? parseInt(signupRole, 10) : null;
    if (!email) {
      toast.error("Enter email");
      return;
    }
    if (!password) {
      toast.error("Enter password");
      return;
    }
    if (!roleId || isNaN(roleId)) {
      toast.error("Select a role");
      return;
    }
    toast.loading("Creating user…", { duration: 2000 });
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    const authHeaders = getAuthHeaders();
    if (authHeaders.Authorization) myHeaders.append("Authorization", authHeaders.Authorization);

    fetch(SERVER_URL + "/users/signup", {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({
        email,
        password,
        first_name: first_name || undefined,
        last_name: last_name || undefined,
        role: roleId,
      }),
      redirect: "follow",
    })
      .then((res) =>
        res.json().then((result) => ({ ok: res.ok, status: res.status, result }))
      )
      .then(({ ok, result }) => {
        const errorMsg = result?.error || result?.message;
        if (!ok || errorMsg) {
          toast.error(errorMsg || "Failed to create user");
          return;
        }
        toast.success("User created successfully");
        this.getUsers();
        this.toggleAddUserModal();
      })
      .catch(() => {
        toast.error("Failed to create user");
      });
  };

  /** True if the role has at least one user whose name or email matches the query (for showing accordion when searching by user). */
  roleHasUserMatchingSearch = (roleId, roleName, q) => {
    const { users } = this.state;
    const roleIdNum = roleId != null && roleId !== "" ? Number(roleId) : NaN;
    const roleNameNorm = roleName != null && roleName !== "" ? String(roleName).trim().toLowerCase() : "";
    const inRole = users.filter((u) => {
      const uRoleId = u.role_id;
      const uRoleStr = u.role != null ? String(u.role).trim().toLowerCase() : "";
      const matchById = !Number.isNaN(roleIdNum) && uRoleId != null && (Number(uRoleId) === roleIdNum || uRoleId == roleId || String(uRoleId) === String(roleId));
      const matchByName = roleNameNorm !== "" && uRoleStr !== "" && uRoleStr === roleNameNorm;
      return matchById || matchByName;
    });
    return inRole.some((u) => {
      const email = (u.email || "").toLowerCase();
      const first = (u.first_name || "").toLowerCase();
      const last = (u.last_name || "").toLowerCase();
      const fullName = `${first} ${last}`.trim() || `${last} ${first}`.trim();
      return email.includes(q) || first.includes(q) || last.includes(q) || fullName.includes(q);
    });
  };

  getFilteredRoles = () => {
    const { roles, search } = this.state;
    if (!search.trim()) return roles;
    const q = search.trim().toLowerCase();
    return roles.filter((r) => {
      const rid = getEntityId(r);
      const name = (r.name || "").toLowerCase();
      const roleName = r.name ?? r.role;
      const id = String(rid ?? "").toLowerCase();
      const roleOrIdMatches = name.includes(q) || id.includes(q);
      const hasUserMatching = this.roleHasUserMatchingSearch(rid, roleName, q);
      return roleOrIdMatches || hasUserMatching;
    });
  };

  /**
   * Returns users assigned to the given role.
   * Matches by role_id (e.g. 40) and by role name (e.g. "ordertracker") so users
   * show under the correct role row even when API uses id vs name differently.
   */
  getUsersForRole = (roleId, roleName) => {
    const { users, search } = this.state;
    const roleIdNum = roleId != null && roleId !== "" ? Number(roleId) : NaN;
    const roleNameNorm = roleName != null && roleName !== "" ? String(roleName).trim().toLowerCase() : "";
    let list = users.filter((u) => {
      const uRoleId = u.role_id;
      const uRoleStr = u.role != null ? String(u.role).trim().toLowerCase() : "";
      const matchById =
        !Number.isNaN(roleIdNum) &&
        uRoleId != null &&
        (Number(uRoleId) === roleIdNum || uRoleId == roleId || String(uRoleId) === String(roleId));
      const matchByName = roleNameNorm !== "" && uRoleStr !== "" && uRoleStr === roleNameNorm;
      return matchById || matchByName;
    });
    if (search.trim()) {
      const q = search.trim().toLowerCase();
      const roleNameMatchesSearch = roleNameNorm !== "" && roleNameNorm.includes(q);
      list = list.filter((u) => {
        if (roleNameMatchesSearch) return true;
        const email = (u.email || "").toLowerCase();
        const first = (u.first_name || "").toLowerCase();
        const last = (u.last_name || "").toLowerCase();
        const fullName = `${first} ${last}`.trim() || `${last} ${first}`.trim();
        return (
          email.includes(q) ||
          first.includes(q) ||
          last.includes(q) ||
          fullName.includes(q)
        );
      });
    }
    return list;
  };

  toggleRoleExpand = (roleId) => {
    const id = roleId != null ? Number(roleId) : roleId;
    this.setState((prev) => {
      const set = new Set(prev.expandedRoleIds);
      if (set.has(id)) set.delete(id);
      else set.add(id);
      return { expandedRoleIds: Array.from(set) };
    });
  };

  isRoleExpanded = (roleId) => {
    const id = roleId != null ? Number(roleId) : roleId;
    return this.state.expandedRoleIds.some((e) => e === id || e === Number(roleId));
  };

  componentDidUpdate(prevProps, prevState) {
    const { search, roles, users } = this.state;
    if (search && search.trim() && search !== prevState.search && users.length > 0) {
      const q = search.trim().toLowerCase();
      const toExpand = [];
      roles.forEach((r) => {
        const rid = getEntityId(r);
        const roleName = r.name ?? r.role;
        if (this.roleHasUserMatchingSearch(rid, roleName, q)) toExpand.push(rid != null ? Number(rid) : rid);
      });
      if (toExpand.length > 0) {
        this.setState((prev) => ({
          expandedRoleIds: [...new Set([...prev.expandedRoleIds, ...toExpand])],
        }));
      }
    }
  }

  componentDidMount() {
    const userStr = localStorage.getItem("user");
    if (userStr) {
      const user = JSON.parse(userStr);
      const roleId = getUserRoleId({ user });
      this.setState({ user });
      this.getRoles();
      this.getUsers();
      if (roleId) this.getTabsByRole(roleId);
    }
  }

  render() {
    const {
      user,
      roleTabs,
      idRoleMap,
      addModalOpen,
      editModalOpen,
      editingRoleName,
      roleName,
      deleteConfirmId,
      isLoading,
      usersLoading,
      addUserModalOpen,
      signupEmail,
      signupPassword,
      signupFirstName,
      signupLastName,
      signupRole,
    } = this.state;

    const filteredRoles = this.getFilteredRoles();

    return (
      <div className="app-layout">
        <Sidebar tabs={roleTabs} user={user} idRoleMap={idRoleMap} />
        <div className="main-content-wrapper">
          <div className="tabs-page-content roles-page-content">
            <div className="tabs-page-inner roles-page-inner roles-page-full">
              <header className="tabs-page-header">
                <div className="tabs-page-header-text">
                  <h1 className="tabs-page-title">Roles & Users</h1>
                  <p className="tabs-page-subtitle">Expand a role to see assigned users. Search by role name or user name.</p>
                </div>
                <div className="tabs-page-header-actions">
                  <button type="button" className="tabs-btn roles-btn-add-user" onClick={this.toggleAddUserModal}>
                    <IoPersonAddOutline size={20} />
                    Add User
                  </button>
                  <button type="button" className="tabs-btn tabs-btn-primary" onClick={this.toggleAddModal}>
                    <IoCreateOutline size={20} />
                    Add Role
                  </button>
                </div>
              </header>

              {this.state.roles.length > 0 && (
                <div className="roles-search-full">
                  <div className="roles-search-field roles-search-field-single">
                    <IoSearchOutline className="tabs-search-icon" size={18} />
                    <input
                      type="text"
                      className="tabs-search-input"
                      placeholder="Search roles and users (by role name or user name)…"
                      value={this.state.search}
                      onChange={(e) => this.setState({ search: e.target.value })}
                      aria-label="Search roles and users"
                    />
                  </div>
                </div>
              )}

              <section className="roles-section roles-section-single">
                <div className="roles-card tabs-card">
                  <div className="tabs-table-wrap roles-table-wrap roles-table-full">
                    {isLoading ? (
                      <div className="roles-loading">Loading roles…</div>
                    ) : filteredRoles.length === 0 ? (
                      <div className="roles-empty">
                        {this.state.roles.length === 0 ? "No roles yet. Add a role to get started." : "No matching roles."}
                      </div>
                    ) : (
                      <table className="tabs-table roles-expand-table">
                        <thead>
                          <tr>
                            <th className="roles-th-expand" />
                            <th>ID</th>
                            <th>Role name</th>
                            <th className="roles-th-count">Users</th>
                            <th className="tabs-table-th-actions">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredRoles.map((role) => {
                            const rid = getEntityId(role);
                            const expanded = this.isRoleExpanded(rid);
                            const roleName = role.name ?? role.role;
                            const usersInRole = this.getUsersForRole(rid, roleName);
                            return (
                              <React.Fragment key={rid}>
                                <tr
                                  className={`roles-row ${expanded ? "roles-row-expanded" : ""}`}
                                  onClick={() => this.toggleRoleExpand(rid)}
                                >
                                  <td className="roles-td-expand">
                                    <span className="roles-expand-icon" aria-hidden>
                                      {expanded ? <IoChevronDownOutline size={18} /> : <IoChevronForwardOutline size={18} />}
                                    </span>
                                  </td>
                                  <td className="tabs-table-id">{rid}</td>
                                  <td className="tabs-table-name">{role.name}</td>
                                  <td className="roles-td-count"><span className="roles-count-pill">{usersInRole.length}</span></td>
                                  <td className="tabs-table-actions" onClick={(e) => e.stopPropagation()}>
                                    <button
                                      type="button"
                                      className="tabs-icon-btn tabs-icon-btn-edit"
                                      onClick={() => this.toggleEditModal(role)}
                                      title="Edit role"
                                    >
                                      <IoCreateOutline size={16} />
                                      Edit
                                    </button>
                                    <button
                                      type="button"
                                      className="roles-delete-btn"
                                      onClick={() => this.deleteRole(rid)}
                                      title="Delete role"
                                    >
                                      <IoTrashOutline size={16} />
                                    </button>
                                  </td>
                                </tr>
                                {expanded && (
                                  <tr className="roles-users-row">
                                    <td colSpan={5} className="roles-users-cell">
                                      <div className="roles-users-inner">
                                        {usersLoading ? (
                                          <div className="roles-users-loading">Loading users…</div>
                                        ) : usersInRole.length === 0 ? (
                                          <div className="roles-users-empty">No users assigned to this role.</div>
                                        ) : (
                                          <ul className="roles-users-list">
                                            {usersInRole.map((u) => {
                                              const uid = u.id ?? u._id ?? u.email;
                                              const fullName = [u.first_name, u.last_name].filter(Boolean).join(" ") || "—";
                                              const initial = (fullName !== "—" ? fullName.charAt(0).toUpperCase() : (u.email || "?").charAt(0).toUpperCase());
                                              return (
                                                <li key={uid} className="roles-user-item">
                                                  <span className="roles-user-avatar" aria-hidden>{initial}</span>
                                                  <span className="roles-user-name">{fullName}</span>
                                                  <span className="roles-user-email">{u.email || "—"}</span>
                                                </li>
                                              );
                                            })}
                                          </ul>
                                        )}
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              </React.Fragment>
                            );
                          })}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>

        {/* Add Modal */}
        <Modal isOpen={addModalOpen} toggle={this.toggleAddModal} className="tabs-modal" contentClassName="tabs-modal-content">
          <ModalHeader toggle={this.toggleAddModal} className="tabs-modal-header">Add Role</ModalHeader>
          <ModalBody className="tabs-modal-body">
            <Form>
              <FormGroup>
                <Label for="roleName">Role Name</Label>
                <Input
                  type="text"
                  id="roleName"
                  name="roleName"
                  placeholder="Enter Role Name"
                  value={roleName}
                  onChange={this.handleInputChange}
                />
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter className="tabs-modal-footer">
            <button type="button" className="tabs-btn tabs-btn-ghost" onClick={this.toggleAddModal}>
              Cancel
            </button>
            <button type="button" className="tabs-btn tabs-btn-primary" onClick={this.onAddRoleSubmit}>
              Add Role
            </button>
          </ModalFooter>
        </Modal>

        {/* Edit Modal */}
        <Modal isOpen={editModalOpen} toggle={() => this.toggleEditModal()} className="tabs-modal" contentClassName="tabs-modal-content">
          <ModalHeader toggle={() => this.toggleEditModal()} className="tabs-modal-header">Edit Role</ModalHeader>
          <ModalBody className="tabs-modal-body">
            <Form>
              <FormGroup>
                <Label for="editingRoleName">Role Name</Label>
                <Input
                  type="text"
                  id="editingRoleName"
                  name="editingRoleName"
                  placeholder="Enter Role Name"
                  value={editingRoleName}
                  onChange={this.handleInputChange}
                />
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter className="tabs-modal-footer">
            <button type="button" className="tabs-btn tabs-btn-ghost" onClick={() => this.toggleEditModal()}>
              Cancel
            </button>
            <button type="button" className="tabs-btn tabs-btn-primary" onClick={this.onUpdateRoleSubmit}>
              Update
            </button>
          </ModalFooter>
        </Modal>

        {/* Add User (Signup) Modal */}
        <Modal isOpen={addUserModalOpen} toggle={this.toggleAddUserModal} className="tabs-modal" contentClassName="tabs-modal-content">
          <ModalHeader toggle={this.toggleAddUserModal} className="tabs-modal-header">Add User</ModalHeader>
          <ModalBody className="tabs-modal-body">
            <Form>
              <FormGroup>
                <Label for="signupEmail">Email</Label>
                <Input
                  type="email"
                  id="signupEmail"
                  name="signupEmail"
                  placeholder="user@example.com"
                  value={signupEmail}
                  onChange={this.handleInputChange}
                />
              </FormGroup>
              <FormGroup>
                <Label for="signupPassword">Password</Label>
                <Input
                  type="password"
                  id="signupPassword"
                  name="signupPassword"
                  placeholder="Password"
                  value={signupPassword}
                  onChange={this.handleInputChange}
                />
              </FormGroup>
              <FormGroup>
                <Label for="signupFirstName">First name</Label>
                <Input
                  type="text"
                  id="signupFirstName"
                  name="signupFirstName"
                  placeholder="First name"
                  value={signupFirstName}
                  onChange={this.handleInputChange}
                />
              </FormGroup>
              <FormGroup>
                <Label for="signupLastName">Last name</Label>
                <Input
                  type="text"
                  id="signupLastName"
                  name="signupLastName"
                  placeholder="Last name"
                  value={signupLastName}
                  onChange={this.handleInputChange}
                />
              </FormGroup>
              <FormGroup>
                <Label for="signupRole">Role</Label>
                <Input
                  type="select"
                  id="signupRole"
                  name="signupRole"
                  value={signupRole}
                  onChange={this.handleInputChange}
                >
                  <option value="">Select role</option>
                  {this.state.roles.map((role) => (
                    <option key={getEntityId(role)} value={getEntityId(role)}>
                      {role.name}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter className="tabs-modal-footer">
            <button type="button" className="tabs-btn tabs-btn-ghost" onClick={this.toggleAddUserModal}>
              Cancel
            </button>
            <button type="button" className="tabs-btn tabs-btn-primary" onClick={this.onAddUserSubmit}>
              Create User
            </button>
          </ModalFooter>
        </Modal>

        {/* Delete confirm Modal */}
        <Modal isOpen={deleteConfirmId != null} toggle={this.cancelDelete} className="tabs-modal" contentClassName="tabs-modal-content">
          <ModalHeader toggle={this.cancelDelete} className="tabs-modal-header">Confirm Delete</ModalHeader>
          <ModalBody className="tabs-modal-body">
            Delete this role? This action cannot be undone.
          </ModalBody>
          <ModalFooter className="tabs-modal-footer">
            <button type="button" className="tabs-btn tabs-btn-ghost" onClick={this.cancelDelete}>
              Cancel
            </button>
            <button type="button" className="tabs-btn roles-btn-danger" onClick={this.confirmDeleteRole}>
              Delete
            </button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default RolesComponent;
